import { Descriptions, Form, Input, Button, Avatar, Space, Checkbox, Card, Typography, Alert, App } from 'antd';

import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { apiClient } from '../../api_actions/index';
import { authClient } from "../../api_actions/auth_index";
import { useNavigate } from 'react-router-dom';
import { formToJSON } from 'axios';

const { Paragraph } = Typography;

export default function Profile(
  {
    readEndpoint,
    updateEndpoint,
    smsReadEndpoint,
    smsUpdateEndpoint
  }
) {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  //const [editing, setEditing] = useState(false);
  const [userData, setUserData] = useState({});
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    loadUserProfile();
    loadSmsSettings();
  }, []);

  const loadUserProfile = async () => {
    try {
      const result = await apiClient.post(readEndpoint);
      if (result.data.length > 0) {
        setUserData(result.data[0]);
      }

    } catch (error) {
      console.error('Failed to load schedules', error);
    }
  };

  const loadSmsSettings = async () => {
    try {
      const result = await apiClient.post(smsReadEndpoint);
      setSmsEnabled(result.data === true);
    } catch (error) {
      console.error('Failed to load SMS settings', error);
    }
  };

  // const handleSave = async () => {
  //   try {
  //     console.log(userData)
  //     const result = await apiClient.post(updateEndpoint, userData);
  //     console.log("LoadResult: ",result)
  //     setUserData(result);
  //     message.success('Profile updated successfully');
  //     //setEditing(false);
  //   } catch (error) {
  //     console.error('Failed to save profile', error);
  //     message.error('Failed to save profile');
  //   }
  // };

  const handleSmsToggle = async (e) => {
    const checked = e.target.checked;
    setSmsEnabled(checked);
  };

  const handleSmsSave = async () => {
    try {
      var sms_payload = {}
      if (smsEnabled) {
        sms_payload['opt_in_timestamp'] = Math.floor(Date.now() / 1000)
      } else {
        sms_payload['opt_out_timestamp'] = Math.floor(Date.now() / 1000)
      }

      const result = await apiClient.post(smsUpdateEndpoint, sms_payload);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } catch (error) {
      console.error('Failed to save SMS settings', error);
      message.error('Failed to save SMS settings');
    }
  };

  return (
    <div>
      {showAlert && (
        <Alert
          message="SMS Settings Updated Successfully"
          type="success"
          banner={true}
          onClose={() => setShowAlert(false)}
          style={{ borderRadius: '5px', marginBottom: '16px', color: 'green' }}
        />
      )}
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center' }}>
          <Avatar size={100} src={userData.avatar}>
            {`${userData.first_name?.[0]}`}
          </Avatar>
        </div>

        {//editing ? 
          // (
          //   <Form
          //     form={form}
          //     layout="vertical"
          //     initialValues={userData}
          //     onFinish={handleSave}
          //   >
          //     <Form.Item label="First Name" name="first_name" rules={[{ required: true }]}>
          //       <Input />
          //     </Form.Item>
          //     <Form.Item label="Last Name" name="last_name" rules={[{ required: true }]}>
          //       <Input />
          //     </Form.Item>
          //     <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email' }]}>
          //       <Input />
          //     </Form.Item>
          //     <Form.Item
          //         label="Password"
          //         name="password"
          //         rules={[
          //         { required: true, message: 'Please enter your password' },
          //         { min: 8, message: 'Password must be at least 8 characters' },
          //         ]}
          //         hasFeedback
          //     >
          //         <Input.Password />
          //     </Form.Item>

          //     <Form.Item
          //         label="Confirm Password"
          //         name="confirm"
          //         dependencies={['password']}
          //         hasFeedback
          //         rules={[
          //         { required: true, message: 'Please confirm your password' },
          //         ({ getFieldValue }) => ({
          //             validator(_, value) {
          //             if (!value || getFieldValue('password') === value) {
          //                 return Promise.resolve();
          //             }
          //             return Promise.reject(
          //                 new Error('The two passwords do not match!')
          //             );
          //             },
          //         }),
          //         ]}
          //     >
          //         <Input.Password />
          //     </Form.Item>

          //     <Space>
          //       <Button type="primary" htmlType="submit">Save</Button>
          //       <Button onClick={() => setEditing(false)}>Cancel</Button>
          //     </Space>
          //   </Form>
          // ) : 
          (
            <>
              <Descriptions
                bordered
                column={1}
              // extra={<Button type="primary" onClick={() => setEditing(true)}>Edit</Button>}
              >
                <Descriptions.Item label="First Name">{userData.first_name}</Descriptions.Item>
                <Descriptions.Item label="Last Name">{userData.last_name}</Descriptions.Item>
                <Descriptions.Item label="Email">{userData.email}</Descriptions.Item>
                <Descriptions.Item label="Phone">{userData.contact_sms}</Descriptions.Item>
              </Descriptions>
            </>
          )}

        <Card title="SMS Notifications">
          <Space direction="vertical" style={{ width: '100%' }}>
            <Checkbox
              checked={userData.contact_sms && smsEnabled}
              onChange={handleSmsToggle}
              disabled={!userData.contact_sms}
            >
              Enable SMS Notifications
            </Checkbox>
            <Paragraph type="secondary">
              By selecting the SMS alert method, you are opting in and consent to receive SMS messages from Orbital Engineering Inc AI Site Monitoring Service at the mobile number you provided. These messages may include updates or other relevant notifications. Your mobile phone number will not be shared with third parties or affiliates for marketing or promotional purposes without your permission. You will receive a subscription message upon clicking save. You can opt out of receiving SMS messages at any time by unselecting SMS alert method or replying with "Stop". Once you opt out, you will no longer receive SMS notifications. For help, reply with "HELP" or contact aiservices@orbitalengr.com. Message frequency may vary. Message and data rates may apply.
            </Paragraph>
            <Button type="primary" disabled={!userData.contact_sms} onClick={handleSmsSave}>
              Save SMS Settings
            </Button>
          </Space>
        </Card>
      </Space>
    </div>
  );
}